module.exports = __webpack_public_path__ + "img/logo.53aca25d.png";